export const POPULATION_DATA: {
  [key: string]: { name: string; color: string; icon: string; label: string };
} = {
  'Niños, Niñas y/o Adolescentes': {
    name: 'niños',
    color: '#F1C40F',
    icon: 'niños.svg',
    label: 'Niños, Niñas y/o Adolescentes',
  },
  'Personas con Discapacidad': {
    name: 'discapacidad',
    color: '#07BC0C',
    icon: 'discapacidad.svg',
    label: 'Personas con Discapacidad',
  },
  'Personas Mayores': {
    name: 'mayores',
    color: '#A947E1',
    icon: 'mayores.svg',
    label: 'Personas Mayores',
  },
  Cuidadores: {
    name: 'cuidador',
    color: '#3498DB',
    icon: 'cuidadores.svg',
    label: 'Personas Cuidadoras',
  },
};

export const SERVICE_DATA: {
  [key: string]: { name: string; label: string };
} = {
  'Cuidado durante el día - Centro Día': {
    label: 'Cuidado durante el día - Centro Día',
    name: 'centro día'
  },
  'Lavandería': {
    label: 'Lavandería',
    name: 'lavandería'
  },
  'Residencia': {
    label: 'Residencia',
    name: 'residencia'
  },
  'Comedor Comunitario': {
    label: 'Comedor Comunitario',
    name: 'comedor comunitario'
  },
  'Transporte de poblaciones específicas': {
    label: 'Transporte de poblaciones específicas',
    name: 'transporte de poblaciones específicas'
  },
  'Centro de Desarrollo Infantil': {
    label: 'Centro de Desarrollo Infantil',
    name: 'centro de desarrollo infantil'
  },
  'Jardín / Guardería Infantil': {
    label: 'Jardín / Guardería Infantil',
    name: 'jardín'
  },
  'Escuela o Colegio': {
    label: 'Escuela o Colegio',
    name: 'escuela',
  },
  'Relevos en la limpieza de espacios': {
    label: 'Relevos en la limpieza de espacios',
    name: 'relevos en la limpieza'
  },
  'Otros': {
    label: 'Otros',
    name: 'otros'
  },
};
